import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SelectBox from "./elements/form/selectBox";
import { Option } from "../_config/types";
import { SUPPORTED_LANGUAGES } from "../i18n/languageConfig";
import { setExplicitLanguage } from "../i18n";

interface LanguageSwitcherProps {
  className?: string;
}

const LANGUAGE_OPTIONS: Option[] = SUPPORTED_LANGUAGES.map((lang) => ({
  label: lang.nativeLabel,
  value: lang.code,
}));

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { i18n } = useTranslation();
  const currentCode = i18n.resolvedLanguage || i18n.language;

  const selectedOption = useMemo(
    () => LANGUAGE_OPTIONS.find((opt) => opt?.value === currentCode) || null,
    [currentCode]
  );

  const handleChange = (option: Option) => {
    if (option) {
      setExplicitLanguage(String(option.value));
    }
  };

  return (
    <div className={className || "w-48"}>
      <SelectBox
        size="md"
        options={LANGUAGE_OPTIONS}
        value={selectedOption}
        onChange={handleChange}
        isClearable={false}
        isSearchable={false}
        className="!my-0"
      />
    </div>
  );
};

export default LanguageSwitcher;
